import type { Question } from "@frontierx/shared/schemas/Question";

import type { AiHelp } from "../Help/AiHelpBrowser";
import type { HandleGetHelpFunction } from "../Help/AiHelpCard";
import { QuestionItem } from "./QuestionItem";

export const QuestionsList = ({
  questions,
  onAnswerQuestion,
  onGetAIHelp,
  aiHistory,
}: {
  questions: Question[];
  onAnswerQuestion: (questionId: string) => void;
  onGetAIHelp: HandleGetHelpFunction;
  aiHistory: AiHelp[];
}) => {
  return (
    <ul>
      {questions
        .sort((a, b) => Number.parseInt(b.id) - Number.parseInt(a.id))
        .map((question) => (
          <QuestionItem
            key={question.id}
            question={question}
            onAnswerQuestion={onAnswerQuestion}
            onGetAIHelp={onGetAIHelp}
            aiHelp={aiHistory.find((ai) => ai.questionId === question.id)}
          />
        ))}
      {questions.length === 0 && (
        <p className="p-4 text-sm text-gray-400">
          Questions asked during the call will appear here
        </p>
      )}
    </ul>
  );
};
